import React, { Component } from "react";
import { connect } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import {
  comparePlan,
  getcmpNames,
  setFormData,
  setStateParams,
} from "../../../Redux/Actions/webAppActions";
import { Text } from "react-internationalization";
import { LANG } from "../../translations/dynamic";

const CustomRadio = withStyles({
  root: {
    height: "30px",
    textAlign: "left",
  },
})(Radio);
const CustomRadioGroup = withStyles({
  root: {
    display: "inline",
    marginLeft: "0",
  },
})(RadioGroup);
const CustomFormControlLabel = withStyles({
  root: {
    // width: "250px"
    //new width: "300px",
    marginLeft: "14px",
    marginRight: "0px",
    textAlign: "left",
  },
})(FormControlLabel);

const CustomRadioFormLabel = withStyles((theme) => ({
  root: {
    width: "135px",
  },
}))(FormControlLabel);

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      categories: [
        {
          //name: "Individual",
          name: "Medicare Advantage Individual Plans",
          value: "INDIVIDUAL",
        },
        {
          // name: "Group",
          name: "Former Sharp HealthCare Retiree Group Medicare Plans",
          value: "GROUP",
        },
        {
          //name: "Retiree",
          name: "Former City of San Diego Retiree (SDPEBA) Group Medicare Plan",
          value: "RETIREE",
        },
      ],
      planIds: [],
      types: ["HMO", "PPO"],
      selectedPlan: this.props.selectedProduct,
      selectedType: this.props.planType ?? "",
      price: "",
      productTypeSelected: this.props.selectedProduct,
      sliderInitial: "50",
      county: this.props.county,
    };
  }
  async componentDidMount() {
    document.getElementById("filter_by").value = 50;
    await this.setState({
      selectedPlan: "",
      selectedType: "",
      price: "",
      sliderInitial: "50",
      productTypeSelected: "",
    });
    this.props.handleReset();
    this.props.setStateParams("selectedProduct", "");
    this.props.setStateParams("planType", "");
  }
  componentDidUpdate(prevState, prevProps) {
    if (
      prevState.zipCode != this.props.zipCode ||
      prevState.county != this.props.county
    ) {
      this.setState({
        selectedPlan: "",
        selectedType: "",
        price: "",
        productTypeSelected: "",
      });
      this.props.handleReset();
      this.props.setStateParams("selectedProduct", "");
    }
  }

  reset = async (e) => {
    e.preventDefault();
    document.getElementById("filter_by").value = 50;
    await this.setState({
      selectedPlan: "",
      selectedType: "",
      price: "",
      sliderInitial: "50",
      productTypeSelected: "",
    });
    this.props.handleReset();
    this.props.setStateParams("selectedProduct", "");
    this.props.setStateParams("planType", "");
  };

  handleChange = async (event, id) => {
    this.props.handleReset2();
    const value = event.target ? event.target.value : event.value;
    if (id === "planSelect") {
      this.props.removeCompareList();
      this.props.handleFilter("productFilter", value);
      this.props.setStateParams("selectedProduct", value);
      this.props.setStateParams("selectedPlansForCompare", []);
      this.props.handleFilter("planTypeFilter", "");
      this.props.setStateParams("planType", "");
      await this.setState({
        selectedPlan: value,
        productTypeSelected: value,
        selectedType: "",
      });
    } else if (id === "plan_type") {
      this.props.handleFilter("planTypeFilter", value);
      this.props.setStateParams("planType", value);
      await this.setState({
        selectedType: value,
      });
    } else {
      this.props.handleFilter("premiumFilter", value);
      await this.setState({
        price: value,
      });
    }
  };

  render() {
    let {
      plans,
      categories,
      selectedPlan,
      // selectedType,
      price,
      //productTypeSelected,
    } = this.state;
    if (this.props.customerId === "HCF0331") {
      plans = categories.map((cat) => {
        if (this.props.lang === "es") {
          cat.name = LANG.CATEGORY[cat.value];
        }
        return cat;
      });
    }
    // let types1 = ["HMO", "PPO"];
    return (
      <div className="inside-panel-box">
        <h6>
          <Text id="app.filterOptions" />
        </h6>
        <div className="row">
          {/* <div className="col-12 col-md-2 col-lg-2" /> */}
          {/* <div className="col-12 col-md-5 col-lg-2 mt-3 mt-lg-0"> */}
          <div className="col-12 col-md-6 col-lg-6 mt-3 mt-lg-0">
            <fieldset className="filter_options">
              <legend>
                <Text id="app.product" />
              </legend>
              <RadioGroup
                aria-label="Plans"
                name="PlanSelect"
                id="planSelect"
                class="sidebar-fontcolor2 text-align-start"
                value={selectedPlan}
                onChange={(e) => {
                  this.handleChange(e, "planSelect");
                }}
              >
                {plans.map((plan, index) => (
                  <CustomFormControlLabel
                    key={index}
                    value={plan.value}
                    control={<CustomRadio color="primary" />}
                    label={plan.name}
                  />
                ))}
              </RadioGroup>
            </fieldset>
          </div>
          {/* <div className="col-12 col-md-5 col-lg-2 mt-3 mt-lg-0">
            <fieldset className="filter_options">
              <legend>
                <Text id="app.plantype" />
              </legend>
              <CustomRadioGroup
                aria-label="plan_type"
                name="plan_type"
                id="plan_type"
                class="sidebar-fontcolor2"
                value={selectedType}
                onChange={(e) => {
                  this.handleChange(e, "plan_type");
                }}
              >
                {productTypeSelected === "GROUP" ||
                productTypeSelected === "RETIREE" ||
                productTypeSelected === "INDIVIDUAL"
                  ?
                    types1.map((type, index) => (
                      <CustomRadioFormLabel
                        key={index}
                        value={type}
                        control={<CustomRadio color="primary" />}
                        label={type}
                      />
                    ))
                  : ""}
              </CustomRadioGroup>
            </fieldset>
          </div> */}
          {/* )} */}
          {/* <div className="col-12 col-md-6 col-lg-3 offset-md-2 offset-lg-0 mt-4 mt-lg-0"> */}
          <div className="col-12 col-md-6 col-lg-3 mt-4 mt-lg-0">
            <label htmlFor="filter_by" className="form-label bold">
              <Text id="app.premium" />
            </label>
            {price.length > 0 && <span class="float-right">${price}</span>}

            <input
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
              id="filter_by"
              type="range"
              class="form-range"
              min="0"
              max="208"
              defaultValue={this.state.sliderInitial}
              onChange={(e) => {
                this.handleChange(e, "price");
              }}
            />
          </div>
          {/* <div className="col-12 col-md-4 col-lg-3 text-end mt-3 mt-md-5 mt-lg-0"> */}
          <div className="col-12 col-md-4 col-lg-2 text-end mt-3 mt-md-5 mt-lg-0">
            <button className="btn btn-secondary" onClick={this.reset}>
              <Text id="app.rfilter" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    agentLogin: state.login.agentLoggedIn,
    county: state.webApp.county,
    customerId: state.login.customerId,
    selectedProduct: state.webApp.selectedProduct,
    lang: state.webApp.language,
    planType: state.webApp.planType,
  };
};
const mapDispatchToProps = {
  comparePlan,
  getcmpNames,
  setFormData,
  setStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBox);
